// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3cfxd","sendOtp":"AuthorizeToLogin_sendOtp__OO8-i"};